import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { WorkTypeRecord } from '../entities/records';
import * as selectors from '../entities/WorkType/selectors';

function mapStateToProps(state, { workTypesIds }) {
  return {
    workTypes: selectors.workTypesByIds(state, workTypesIds),
  };
}

export default compose(
  setPropTypes({
    workTypesIds: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    workTypes: PropTypes.arrayOf(PropTypes.instanceOf(WorkTypeRecord)),
  }),
)(mapStateToProps);
